module.exports = __webpack_public_path__ + "img/22.1f03b866.jpg";